/* unplugin-vue-components disabled */import script from "./InformationBinding.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationBinding.vue?vue&type=script&lang=ts&setup=true"

import "./InformationBinding.vue?vue&type=style&index=0&id=7b68acb3&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b68acb3"]])

export default __exports__